import React from "react";
import {
  Page,
  Document,
  View,
  Text,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import logotipo from "../../assets/img/logotipo.png";
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#E4E4E4",
    paddingHorizontal: 20,
    paddingVertical: 30
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    marginBottom: 20
  },
  label: {
    fontSize: 14,
    fontWeight: "bold"
  },
  value: {
    fontSize: 14
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10
  },
  imageSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "50pt"
  },
  image: {
    width: "100pt",
    height: "100pt"
  }
});

const DocumentRecibo = ({ infoContract }) => {
  const { contrato, infoContrato } = infoContract;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image
          style={[styles.imageSection, styles.image]}
          src={logotipo}
          align="center"
        />
        <View style={styles.section}>
          <Text style={styles.title}>Recibo de Contrato</Text>
          <View style={styles.row}>
            <Text style={styles.label}>Número de contrato:</Text>
            <Text style={styles.value}>{contrato.NUMCONTRATO}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Costo total:</Text>
            <Text style={styles.value}>${infoContrato.pcostoTotal}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Superficie total:</Text>
            <Text style={styles.value}>{infoContrato.psuperficieTotal} m²</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Mensualidades:</Text>
            <Text style={styles.value}>{infoContrato.pmensualidades}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Monto de la mensualidad:</Text>
            <Text style={styles.value}>${infoContrato.pmontoMensualidad}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default DocumentRecibo;
